import { cn } from '@sib/ui';
import { SingleSelectCheck, Tag } from '@sib/ui/icons';
import { ComboboxTagOptionProps } from '@sib/ui/types';

interface SelectedTagsHeaderProps {
  selectedOptions: ComboboxTagOptionProps[];
  selectedValues: string[];
  onToggleTag: (value: string, field?: string) => void;
}

export const SelectedTagsHeader = ({
  selectedOptions,
  selectedValues,
  onToggleTag,
}: SelectedTagsHeaderProps) => {
  if (selectedOptions.length === 0) return null;

  return (
    <div className="flex max-h-[200px] flex-col overflow-y-auto border-b">
      {selectedOptions.map(opt => {
        const isSelected = selectedValues.includes(opt.value);

        return (
          <div
            key={opt.value}
            onClick={e => {
              e.stopPropagation();
              onToggleTag(opt.value, opt.field);
            }}
            className="group hover:bg-surface-soft flex cursor-pointer items-center justify-between gap-2 px-4 py-2"
          >
            <div className="flex items-center gap-2">
              <Tag style={{ color: opt.color }} />
              <span
                className={cn(
                  'text-sm leading-6 font-medium',
                  isSelected ? 'text-primary' : 'text-primary/50'
                )}
              >
                {opt.label}
              </span>
            </div>
            {isSelected && (
              <SingleSelectCheck className="text-primary size-4 min-w-4 stroke-2" />
            )}
          </div>
        );
      })}
    </div>
  );
};
